import _ from 'lodash'

//展示错误信息
export const showError = ({commit,dispatch}, {msg}) => {
    commit('addError', {msg});
    dispatch('hideError');
}

//定时隐藏错误信息
export const hideError = _.debounce(({commit})=>{
    commit('delError');
}, 3000)



// WEBPACK FOOTER //
// ./src/store/actions.js